package ui.new_ui.color_scheme

import react.useContext
import ui.themePlusContext.MyContext
import ui.themePlusContext.ThemesMode
import web.cssom.Color
import web.cssom.rgb

object MainColorScheme {
    object MainColors{
        val mainColorContainer = rgb(57,49,133)
        val mainColorOnContainer = Color("white")
    }

    object SecondaryColors{
        fun secondaryColorContainer() = useTheme(
            onLightTheme = { Color("white") },
            onDarkTheme = { rgb(47,47,53) }
        )
        fun secondaryColorOnContainer() = useTheme(
            onLightTheme = {Color("black")},
            onDarkTheme = {Color("white")}
        )
    }

    object TertiaryColors{
        fun tertiaryColorContainer() = useTheme(
            onLightTheme = { rgb(196, 188, 196) },
            onDarkTheme = { rgb(37,36,39) }
        )
        val tertiaryColorOnContainer = Color("white")
    }

    object BackgroundColors{
        fun backgroundColorContainer() = useTheme(
            onLightTheme = { rgb(233, 224, 240) },
            onDarkTheme = { rgb(13, 14, 15) }
        )
        fun backgroundColorOnContainer() = useTheme(
            onLightTheme = { Color("black") },
            onDarkTheme = { rgb(219,219,219) }
        )
        fun backgroundColorOnContainerReversed() = useTheme(
            onLightTheme = { Color("white") },
            onDarkTheme = { Color("black") }
        )
    }

    object AccentColors{
        fun expandedTextBackgroundColor() = useTheme(
            onLightTheme = { rgb(255, 219, 139) },
            onDarkTheme = { rgb(87,78,89) }
        )
    }
}

private fun <T> useTheme(
    onLightTheme:()->T,
    onDarkTheme:()->T,
): T{
    val getTheme = useContext(MyContext).themeMode
    return when(getTheme){
        ThemesMode.LIGHT -> onLightTheme()
        ThemesMode.DARK -> onDarkTheme()
    }
}